<template>
  <div class="image-upload">
    <div class="image-preview">
      <template v-if="preview">
        <div class="image-preview-item" v-for="(img, i) in imgPreview" :key="i">
          <div class="img">
            <img :src="img.data" />
          </div>
          <div class="cancelBtn" @click="cancelInputImg">
            <img :src="require('../../assets/img/cancel.svg')" />
          </div>
        </div>
      </template>
      <label
        v-if="!imgPreview.length || keepBtn"
        class="image-upload-btn"
        :class="[{ loading: loading }, { noBorder: noBorder }]"
      >
        <input
          id="fileName"
          type="file"
          ref="inputFiles"
          accept="image/*"
          @change="handleFiles"
          style="display: none;"
        />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadImg',
  props: {
    preview: {
      type: Boolean,
      default: true,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    keepBtn: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      imgPreview: [],
      loading: false,
    }
  },
  
  methods: {
    async handleFiles() {
      this.loading = true
      this.$emit('loading', true)
      const imgs = await Promise.all(
        Array.from(event.target.files).map(file => {
          return this.readAsDataURL(file)
        })
      )
      this.imgPreview = imgs
      this.$emit('onloadend', this.imgPreview)
    },
    readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onloadend = () => {
          this.loading = false
          this.$emit('loading', false)
          if (fileReader.result && fileReader.result.indexOf('image') > 0) {
            return resolve({
              data: fileReader.result,
            })
          } else {
            document.getElementById('fileName').value = ''
            this.$bus.$emit('callAllert', {
              messageContent:
                '圖片上傳失敗' +
                (fileReader.error ? fileReader.error.message : ''),
            })
            return reject(new Error('圖片上傳失敗'))
          }
        }
        fileReader.readAsDataURL(file)
      })
    },
    cancelInputImg() {
      this.imgPreview = []
      if (this.keepBtn) {
        document.getElementById('fileName').value = ''
      }
    },
  },
  watch: {
    imgPreview (newArr) {
      newArr[0] ? this.$emit('hasImg', true) : this.$emit('hasImg', false)
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.image-upload {
  display: flex;
  flex-flow: row;
  width: 100%;

  .image-upload-btn {
    width: 48px;
    height: 48px;
    flex: 0 0 auto;
    border-radius: 8px;
    border: 1px solid #8e9091;
    display: inline-block;
    background-image: url('~@/assets/img/icon/upload-plus.svg');
    background-position: center;
    background-size: 24px 24px;
    &.loading {
      opacity: 0.5;
      position: relative;
      &::after {
        width: 38px;
        height: 38px;
        display: block;
        position: absolute;
        top: 17px;
        left: 17px;
        content: '';
        background-image: url('../../assets/img/loading-red.svg');
        animation-name: spin;
        animation-duration: 1500ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        filter: grayscale(1);
      }
    }
    &.noBorder {
      margin-right: 0;
      width: 28px;
      height: 28px;
      border: none;
      background-color: transparent;
      background-image: url('~@/assets/img/icon/chatroom_upload.svg');
      &.loading {
        &::after {
          width: 30px;
          height: 30px;
          top: -2.5px;
          left: -2.5px;
          background-size: contain;
        }
      }
    }
  }
  .image-preview {
    display: flex;
    flex-flow: row wrap;
    .image-preview-item {
      width: 48px;
      position: relative;
      img {
        width: 100%;
        border-radius: 8px;
      }
      .cancelBtn {
        background-color: #fff;
        border-radius: 100%;
        position: absolute;
        width: 20px;
        height: 20px;
        top: -10px;
        right: -10px;
      }
    }
  }
}
</style>
